<mat-dialog-title>
    {{ dialogTitle }} for the following {{ employeeText.toLowerCase() }}:
</mat-dialog-title>
<mat-dialog-content class="dialog-content lg-scrollbar">
    <cdk-virtual-scroll-viewport
        itemSize="68"
        minBufferPx="employees.length * 68"
        maxBufferPx="(employees.length * 68) * 2"
        style="height: 55vh"
    >
        <mat-list twoLine>
            <mat-list-item
                class="list-item"
                *cdkVirtualFor="let emp of employees"
                style="display: flex"
            >
                <p-checkbox
                    #employee
                    class="dialog-checkbox"
                    [(ngModel)]="emp.convertToUser"
                    [binary]="true"
                    (onChange)="checkChange(employee)"
                />
                <button mat-button (click)="labelClick(employee, emp)">
                    <mat-list-item-text [secondaryText]="emp.loginEmail">
                        {{ emp.firstName }} {{ emp.lastName }}
                    </mat-list-item-text>
                </button>
            </mat-list-item>
        </mat-list>
    </cdk-virtual-scroll-viewport>
</mat-dialog-content>
<mat-dialog-actions class="button-section">
    <button mat-raised-button mat-dialog-close class="main-button">Cancel</button>
    <button
        mat-raised-button
        [disabled]="userCount <= 0"
        class="main-button"
        (click)="convertEmployees()"
    >
        {{ actionTextProper }} {{ userCount }} {{ userText.toLowerCase() }}
    </button>
    <div *ngIf="showWelcomeEmailCheck">
        <span class="welcomeEmailLabel"> Also Send Welcome Email </span>
        <span>
            <p-checkbox class="dialog-checkbox" [(ngModel)]="welcomeEmail" [binary]="true" />
        </span>
    </div>
</mat-dialog-actions>
